import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

import { computed, ref, watch } from 'vue';

type PopoverTrigger = 'click' | 'hover';

type Props = {
  trigger?: PopoverTrigger;
  align?: string;
  detached?: boolean;
};


export default _defineComponent({
  props: {
    trigger: { type: String, required: false, default: 'click' },
    align: { type: String, required: false, default: 'right' },
    detached: { type: Boolean, required: false, default: false }
  } as unknown as undefined,
  emits: ["show", "hide"] as unknown as undefined,
  setup(__props: {
  trigger?: PopoverTrigger;
  align?: string;
  detached?: boolean;
}, { emit }: { emit: ({
  (e: 'show'): void;
  (e: 'hide'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
_useCssVars(_ctx => ({
  "72dd16b0": (_unref(activatorHalfWidthPx)),
  "0468aa4a": (_unref(activatorWidthPx))
}))





/**
 * STATE
 */
const popoverOpened = ref(false);
const activatorWrapper = ref<HTMLDivElement>();

/**
 * COMPUTED
 */
const popoverWrapperClasses = computed(() => ({
  'bal-popover-wrapper-visible': popoverOpened.value,
  [`${props.align}-0`]: !props.detached,
  'align-center-transform': props.detached && props.align === 'center',
  'align-right-transform': props.detached && props.align === 'right',
}));

const popoverActivatorWrapperClasses = computed(() => ({
  relative: !props.detached,
}));

const activatorWidth = computed(() => 24);

const activatorWidthPx = computed(() => `${activatorWidth.value}px`);

const activatorHalfWidthPx = computed(() => `${activatorWidth.value / 2}px`);

/**
 * METHODS
 */
function togglePopover() {
  popoverOpened.value = !popoverOpened.value;
}

function showPopover() {
  popoverOpened.value = true;
}

function hidePopover() {
  popoverOpened.value = false;
}

function handleClickOutside() {
  if (props.trigger === 'click') {
    hidePopover();
  }
}

/**
 * WATCHERS
 */
watch(popoverOpened, () => {
  if (popoverOpened.value) {
    emit('show');
  } else {
    emit('hide');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BalCard = _resolveComponent("BalCard")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(popoverActivatorWrapperClasses)])
  }, [
    _createElementVNode("div", {
      ref: activatorWrapper,
      class: "bal-popover-activator group",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.trigger === 'click' && togglePopover())),
      onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (__props.trigger === 'hover' && showPopover())),
      onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (__props.trigger === 'hover' && hidePopover()))
    }, [
      _renderSlot(_ctx.$slots, "activator")
    ], 544),
    _createElementVNode("div", {
      class: _normalizeClass(['bal-popover-wrapper', _unref(popoverWrapperClasses)])
    }, [
      _createVNode(_component_BalCard, _mergeProps({ shadow: "lg" }, _ctx.$attrs, {
        darkBgColor: "true",
        noBorder: ""
      }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", { close: hidePopover })
        ]),
        _: 3
      }, 16)
    ], 2)
  ], 2)), [
    [_directive_click_outside, handleClickOutside]
  ])
}
}

})